import * as React from "react";
import Props from "./index.d";
import GridBase from "../gridBase";

interface GFCFieldSet_Horizontal extends Props {
  children: React.ReactNode;
}

const GridContainer: React.FC<GFCFieldSet_Horizontal> = (props) => {
  return (
    <GridBase container {...props}>
      {props.children}
    </GridBase>
  );
};
export default GridContainer;
